import moment from 'moment';
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter,Prompt } from 'react-router-dom';
import { addPassengersDetails } from '../../Redux/travelShop/TravelAction';
import TravelShopHOC from './TravelShopHOC';
import PassengerInputField from './PassengerInputField';
import Policy from './Policy.jsx';
import PrivacyTerms from './PrivacyPolicy.txt';
import TermsCondition from './TermsCondition.txt'
import { passengerTermsEnglish, passengerTermsArabic, privacyPolicyEnglish, privacyPolicyArabic } from './termsDetails';
import phoneNumberCode from "../../utils/countrycodes/phoneNoCode.json"
import { parsePhoneNumber } from 'libphonenumber-js';

let passportIssuedCountryList = ["Afghanistan","Albania","Algeria","Andorra","Angola","Antigua and Barbuda","Argentina","Armenia","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Central African Republic","Chad","Chile","China","Colombia","Comoros","Congo","Costa Rica","Croatia","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","DR Congo","East Timor","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia","Fiji","Finland","France","Gabon","Gambia","Georgia","Germany","Ghana","Greece","Grenada","Guatemala","Guinea","Guinea-Bissau","Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy","Ivory Coast","Jamaica","Japan","Jordan","Kazakhstan","Kenya","Kiribati","Kosovo","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","New Zealand","Nicaragua","Niger","Nigeria","North Korea","North Macedonia","Norway","Oman","Pakistan","Palau","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Qatar","Romania","Russia","Rwanda","Saint Kitts and Nevis","Saint Lucia","Saint Vincent and the Grenadines","Samoa","San Marino","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Korea","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Togo","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan","Vanuatu","Vatican City","Venezuela","Vietnam","Yemen","Zambia","Zimbabwe"]

let nationalityList = ["Afghan","Andorran","Antillean","Argentinian","Australian","Austrian","Belgian","Bolivian","Brazilian","Bulgarian","Burman","Cambodian","Cameroun","Ceylonese","Chilean","Chinese","Colombian","Congolese","Costa Rican","Croatian","Cuban","Cypriot","Czech","Danish","Dominican","Ecuadorians","Egyptian","Salvadoran" ,"Salvadorian","English","Ethiopian","Finnish","French","Gabonese","Gambian","German","Ghanian" ,"Ghanaian","British","Greek","Guatemalan","Guinean","Haitian","Dutch","Honduran","Hungarian","Icelander","Indian","Iranian","Irakian" ,"Iraki","Irish","Israeli","Italian","Jamaican","Japanese","Jordanian","Kenyan","Korean","Kuwaiti","Laotian","Latvian","Lebanese","Liberian","Lybian","Luxembourger","Malayan","Malian","Maltese","Mauritanian","Mexican","Monegasque","Moroccan","Nepali","Nepalese","New Zelander","Nicaraguan","Nigerian","Norwegian","Pakistani","Panamanian","Paraguayan","Peruvian","Filipino","Polish","Portuguese","Puerto Rican","Rhodesian","Romanian","Russian","Rwandese","San Marinese","Saudi Arabian","Scottish","Senegalese","Somalian","South African","Spanish","Sudanese","Swedish","Swiss","Syrian","Tanzanian","Thai","Togolese","Tunisian","Turkish","Ugandan","Ukrainian","North American","Uruguayan","Venezuelan","Vietnamese","Welsh","Yemeni","Zairian","Zambian"]
class PassengerDetails extends Component {
    constructor(props){
        super(props);
        this.myRef = React.createRef();
        this.state={
            formFields:{
                title:{id:"title",title:"Title",type:"dropdown",value:"Mr",required:true,tabIndex:"1",readOnly:false,ariaLabel:"Gender",errorMessage:"",options:['Mr','Miss','Mrs'],fullWidth:true},
                first_name:{id:"first_name",title:"First Name",type:"text",value:"",required:true,tabIndex:"2",readOnly:false,ariaLabel:"Enter your first name",errorMessage:""},
                last_name:{id:"last_name",title:"Last Name",type:"text",value:"",required:true,tabIndex:"3",readOnly:false,    ariaLabel:"Enter your last name",errorMessage:""},
                email:{id:"email",title:"Email",type:"email",value:"",required:true,tabIndex:"4",readOnly:false,ariaLabel:"Enter your Email ID",errorMessage:""},
                date_of_birth:{id:'date_of_birth',title:'Date of Birth',type:"date",value:"",required:true,tabIndex:"5",readOnly:false,ariaLabel:"Enter your Date of Birth",errorMessage:"",maxDate:new Date(new Date().setFullYear(new Date().getFullYear() + 100))},
                nationality:{id:"nationality",title:"Nationality",type:"dropdown",value:"Saudi Arabian",required:true,tabIndex:"6",readOnly:false,ariaLabel:"Select your country",errorMessage:"",options:nationalityList,fullWidth:true},
                // country:{id:"country",title:"Country",type:"dropdown",value:"Saudi Arabia",required:true,tabIndex:"7",readOnly:false,ariaLabel:"select your country",errorMessage:"",options:["Saudi Arabia"],fullWidth:true,disable:true},
                // city:{id:"city",title:"City",type:"dropdown",value:"Al Riyadh",required:true,disabled:true,tabIndex:"7",readOnly:false,ariaLabel:"select your country",errorMessage:"",options:["Riyadh","Jeddah"],fullWidth:true},
                // mobile_country_code:{id:"mobile_country_code",title:"Country Code",type:"dropdown",value:"966",required:true,tabIndex:"9",readOnly:false,ariaLabel:"Select your country",errorMessage:"",options:["966"],fullWidth:true,disable:true},
                mobile_number:{id:"mobile_number",title:"Mobile Number",type:"tel",value:"",required:true,tabIndex:"7",readOnly:false,ariaLabel:"Enter Your Mobile Number",errorMessage:"",maxLength:9,fullWidth:true},
                number:{id:"number",title:"Passport Number",type:"text",value:"",required:true,tabIndex:"8",readOnly:false,ariaLabel:"Enter your passport number",errorMessage:"",maxLength:15},
                expiry_date:{id:"expiry_date",title:"Passport Expiry Date",type:"date",value:"",required:true,tabIndex:"9",readOnly:false,ariaLabel:"Select your Passport Expiry Date",errorMessage:""},
                issued_country:{id:"issued_country",title:"Passport Issued Country",type:"dropdown",value:"Saudi Arabia",required:false,tabIndex:"10",readOnly:false,ariaLabel:"select your issued country",errorMessage:"",options:passportIssuedCountryList,fullWidth:true,disable:false},
                issued_date:{id:"issued_date",title:"Passport Issued Date",type:"date",value:"",required:false,tabIndex:"11",readOnly:false,ariaLabel:"Select your Passport Issued Date",errorMessage:""},
                // address_line1:{id:"address_line1",title:"Address",type:"text",value:"",required:true,tabIndex:"12",readOnly:false,ariaLabel:"",errorMessage:""},
            },
            termsNotAccepted:true,
            terms1:false,
            policy:false,
            continueButton:true,
            privacyPolicy:'',
            termsCondition:'',
            phoneCode:this.props.passengerDetails?.[this.props.match?.params?.number -1]?.phoneCode || "",
        }
    }
   
    componentDidMount(){
        
        this.myRef.current?.scrollIntoView({behavior: "smooth"})
        if(this.props.match?.params?.number > this.props.passengerCount){
           return this.props.history.replace('/404')
        }
        if(this.state.phoneCode === ""){
          this.handlePhoneCode()
        }
        let updatedformFields = {...this.state.formFields};
        ['first_name','email','last_name','mobile_number'].forEach(property => {
            if(property === 'mobile_number'){
                updatedformFields[property].value = this.props.contactDetails['phone'];
            }
            else{
                updatedformFields[property].value = this.props.contactDetails[property];
            }
            updatedformFields[property]['isClearable'] = true
        })
        if(this.props.location?.state?.editParam || this.props.passengerDetails[this.props.match?.params?.number - 1]){
            this.formFieldValidation(true)
        }
        else{
            this.formFieldValidation()
        }
        fetch(PrivacyTerms).then((r) => r.text()).then(text  => {
          this.setState({privacyPolicy:text})
        })  
        fetch(TermsCondition).then((r) => r.text()).then(text  => {
            this.setState({termsCondition:text})
          })  
    }

    componentDidUpdate(prevProps){
        if(this.props.match?.params?.number !== prevProps.match?.params?.number){
            this.myRef.current?.scrollIntoView({behavior: "smooth"})
            this.handlePhoneCode(this.props.passengerDetails?.[this.props.match?.params?.number - 1]?.phoneCode)
            this.setState({continueButton:true});
            if(this.props.location?.state?.editParam || this.props.passengerDetails[this.props.match?.params?.number - 1]){
                    this.formFieldValidation(true);
                }
            else if(this.props.match.params?.number > 1){
                let updatedformFields = {...this.state.formFields};
                ['first_name','last_name'].forEach(prop => {
                    updatedformFields[prop]['isClearable'] = false
                });
                ['email','mobile_number'].forEach(property => {
                    updatedformFields[property].value = this.props.passengerDetails[0][property];
                    updatedformFields[property]['isClearable'] = true
                })
            }
        }
    }
    setInputValue=(val,feild)=>{
        let updatedformFields = {...this.state.formFields}
        if(feild === 'mobile_number'){
            if(val?.startsWith(0)) val = val?.slice(1)
            updatedformFields[feild].value = val.replace(/\D/g, "");  
        }
        else if((updatedformFields[feild]?.type === 'text' || updatedformFields[feild]?.type === "email") && val){
            let regforeng = /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._,-]+$/g
            if(regforeng.test(val)){
                updatedformFields[feild].value = val;
            }
        }
        else{
            updatedformFields[feild].value = val;
        }
        updatedformFields[feild].errorMessage = ""
        this.setState({
            formFields:updatedformFields
        })
    }

    handlePhoneCode = (val) =>{
        if(val) {
            this.setState({phoneCode:val})
            return
        }
        const phoneCode = phoneNumberCode?.filter((val)=>val?.name === this.props.SelectedCountryName)
        this.setState({phoneCode:phoneCode?.[0]?.dial_code || "966"})
    }
    
      setEditValue = () => {
        let passengerID = Number(this.props.match?.params?.number) - 1;
        let passengerDetails = this.props.passengerDetails?.[passengerID];
        let updatedformFields = {...this.state.formFields};
        if(passengerDetails && Object.keys(passengerDetails)){
            Object.keys(passengerDetails)?.forEach(e => updatedformFields[e] ? updatedformFields[e].value = passengerDetails[e] : null);
            this.setState({formFields:updatedformFields})
        }
      }

    formFieldValidation = (editData) => {
        if(this.props.flightDetails){
        const {valid_documents,is_passport_info_req,is_passport_full_info_req,is_document_info_req} = this.props.flightDetails
        let updatedformFields = {...this.state.formFields};
        if(is_passport_info_req && is_passport_full_info_req ){
            ['issued_country','issued_date'].forEach(e => updatedformFields[e] ? updatedformFields[e].required = true : updatedformFields[e].required = false)
        }
        else if(is_document_info_req && valid_documents?.NationalId ){
            let nationalID = updatedformFields['number']
            nationalID.ariaLabel = 'Enter your National ID';
            nationalID.title = 'National ID'
        }
        else if(is_document_info_req && valid_documents?.Iqama ){
            let iqama = updatedformFields['number']
            iqama.ariaLabel = 'Enter your Iqama ID';
            iqama.title = 'Iqama'
            updatedformFields['issued_country'].required = true
        }
        else if(valid_documents && Object.keys(valid_documents)?.length === 0){
            ['number','issued_country','issued_date','expiry_date'].forEach(e => delete updatedformFields[e])
        }
        if(editData){
            this.setState({formFields:updatedformFields},()=>{this.setEditValue()})
        }else{
            this.setState({formFields:updatedformFields})
        }
        }
        
    }  


    clearSpecificField = (feild) => {
        let updatedformFields = {...this.state.formFields}
        updatedformFields[feild].value = '';
        updatedformFields[feild].isClearable = false
        this.setState({
            formFields:updatedformFields
        })
    }
    clearInputField = () => {
        let updatedformFields = {...this.state.formFields};
        let vomitFields = ['title','nationality','country','mobile_country_code','issued_country']
        Object.keys(updatedformFields).forEach(e => (! vomitFields.includes(updatedformFields[e].id)) ? updatedformFields[e].value = '' : false)
        this.setState({formFields: updatedformFields},
            () => {
                this.props.match?.params?.number == this.props.passengerCount ? 
                this.props.history.push('/travel-details') 
                : 
                this.props.history.push({
                    pathname:`/passenger-details/${Number(this.props.match.params.number) + 1}`,
                    state:{editParam:this.props.location?.state?.editParam || false}
                })
            })
    }


    validateForm=()=>{
        const {t,flightDetails}= this.props
           let valid = true;
           const phoneNoCode = phoneNumberCode?.filter(val => val?.dial_code === this.state.phoneCode)
           let updatedformFields = {...this.state.formFields};
           let depTime = flightDetails?.segments?.[0]?.departure_time;
           let ageError = this.validateAge(updatedformFields['date_of_birth'].value);
           Object.values(this.state.formFields).forEach(feild=>{
               if(feild.value==="" && feild.required){
                   updatedformFields[feild.id].errorMessage=`${feild.title} is missing`
                   valid=false
               }
           });
           var re = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
            if (!re.test(updatedformFields['email']?.value)){
                updatedformFields['email'].errorMessage = "Invalid Email"
                updatedformFields['email'].value="";
                valid=false
            }
            if(updatedformFields['mobile_number'].value !=="" && parsePhoneNumber(`${updatedformFields['mobile_number'].value}`, phoneNoCode?.[0]?.code)?.isValid() === false){
                updatedformFields['mobile_number'].errorMessage = "Invalid Number"
                updatedformFields['mobile_number'].value="";
                valid = false
            }
            if(moment(updatedformFields['expiry_date']?.value).diff(depTime, 'months') <= 5 && updatedformFields['number']?.title === 'Passport Number'){
                updatedformFields['expiry_date'].errorMessage = "Your passport is about to expire, please renew it before booking the flight"
                updatedformFields['expiry_date'].value="";
                valid=false
            }
            if(ageError){
                updatedformFields['date_of_birth'].errorMessage = ageError
                updatedformFields['date_of_birth'].value="";
                valid=false
            }
            if(moment(updatedformFields['issued_date']?.value) <= moment(updatedformFields['date_of_birth']?.value) && (updatedformFields['issued_date']?.required || updatedformFields['issued_date']?.value !== '')){
                updatedformFields['issued_date'].errorMessage ="Invalid Issue date";
                updatedformFields['issued_date'].value="";
                valid=false
            }else if(moment(updatedformFields['issued_date']?.value).format("YYYY-MM-DD") > moment(new Date()).format("YYYY-MM-DD") && (updatedformFields['issued_date']?.required || updatedformFields['issued_date']?.value !== '')){
                updatedformFields['issued_date'].errorMessage ="Invalid Issue date";
                updatedformFields['issued_date'].value="";
                valid=false
            }
            if(this.props.match.params.number !== "1" && updatedformFields['number']){
                for(let i = 0 ;i < +this.props.match.params.number - 1 ; i++){
                    if(updatedformFields['number']?.value === this.props.passengerDetails[i]?.['number']){
                        updatedformFields['number'].errorMessage = "Enter unique passport number"
                        updatedformFields['number'].value="";
                        valid=false
                    }
                }
            }
           this.setState({
               formFields:updatedformFields
           })
           
           if(valid){
            this.setState({continueButton:false},()=>{
                let newPassengerDetail = {};
                for ( var key in this.state.formFields ) {
                    newPassengerDetail[key] = this.state.formFields[key].value
                }
                newPassengerDetail['phoneCode'] = this.state.phoneCode
                
                this.props.addPassengerDetails(newPassengerDetail,Number(this.props.match.params.number))
                this.clearInputField()
                })
           }
       }
    
    formTitle = () =>{
        const urlParam = Number(this.props.match.params.number);
        const {passengerCount,t} = this.props
        const {adults,child} =  this.props.passengerCountDetails;
        if (urlParam <= adults){
            return `${urlParam} : ${t('Adult')}`
        }
        else if(urlParam > adults && urlParam <= child + adults){
            return `${urlParam} : ${t('Child')}`
        }
        else if(urlParam > child && urlParam <= passengerCount){
            return `${urlParam} : ${t('Infant')}`
        }
    }
   validateAge = (dob) => {
        let passengerType = this.formTitle().split(':')[1];
        let age = moment().diff(dob, 'years',true);
        if((passengerType === ' Adult' || passengerType === ' البالغ') && age < 12 ){
            return 'Age should be 12+'
        }
        else if((passengerType === ' Child' || passengerType === ' أطفال') && (age > 12 || age < 2)) {
            return "Age should be between 2 - 12"
        }
        else if((passengerType === ' Infant' || passengerType === ' رضيع') && (age > 2 || moment().diff(dob,'days') <= 0)){
            return "Age should be less than 2"
        }
        else return false

   }
    closeModal=()=> {
        this.setState ({
            terms1:false,
            policy:false
        })
    }
  

    render() {
        const {t} = this.props
        const customizeNodal  = {    
                opacity: ".5 !important"
          };
          
        return (
            <div ref={this.myRef}>
            <Policy
            lang={this.props.lang}
                style={customizeNodal}
                showModal = {this.closeModal}
                show = {this.state.policy}
                title="Privacy Policy"
                contentInEnglish={privacyPolicyEnglish} 
                contentInArabic={privacyPolicyArabic} 
                />
                <Policy
                style={customizeNodal}
                lang={this.props.lang}
                showModal = {this.closeModal}
                show = {this.state.terms1}
                title="Terms of Use"
                contentInEnglish={passengerTermsEnglish}
                contentInArabic={passengerTermsArabic}
                />
            <Prompt
            when={this.state.continueButton}
            message="Are you sure you want to leave?"
            />
                <TravelShopHOC 
                lang= {this.props.lang}
                childComponent={
                    <div className='travelBoxShadow bg-white p-4'>
                <div className="">
                    <h4 className="fw-bold color-blue">{t("Passenger")} {this.formTitle()}</h4>
                    <p className="fw-bold color-red">
                       {t("Please be careful - Passenger details must match Passport or National ID")}
                    </p>
                </div>
                    <div className=" row travelShopPassenger">
                {
                    Object.values(this.state.formFields).map(f=>(
                        <PassengerInputField data={f} key={f.id} onChange={this.setInputValue}  clearSpecificField={this.clearSpecificField} lang={this.props.lang} phoneCode={this.state.phoneCode} handlePhoneCode={this.handlePhoneCode}/>
                    ))
                }
               {
                  this.props.match?.params?.number == this.props.passengerCount ? <>
                   <div className='py-2 col-12 d-flex gap-2'>
                   <input onChange={()=>this.setState({termsNotAccepted: !this.state.termsNotAccepted})} type="checkbox" className='flex-shrink-0' />
                       <label className='text-muted'>{t("By proceeding with the booking ")}{t("I agree to")} <span className='color-green cursor-pointer' onClick={()=> this.setState({terms1: true})} >{t("Terms of Use")}</span> {t("and")} <span  className='color-green cursor-pointer' onClick={()=> this.setState({policy: true})}>{t("Privacy Policy")}</span></label>
                   </div>
                   <div className="py-2 col-12 d-flex justify-content-end align-items-center p-details-button">
                           <button onClick={this.validateForm} disabled={this.state.termsNotAccepted} className="btn btn-sky rounded-0 d-block d-md-none w-100">
                           {t("Save and Continue")}
                           </button>
                           <button onClick={this.validateForm} disabled={this.state.termsNotAccepted} className="btn btn-sky rounded-0 d-none d-md-block" tabIndex={'14'}>
                           {t("Save and Continue")}
                           </button>
                   </div>
                   </> : 
                   <>
                   <div></div>
                   <div className="py-2 col-12 d-flex justify-content-end align-items-center p-details-button ">
                        <button onClick={this.validateForm} className="btn btn-sky rounded-0 p-details-button" tabIndex={'14'}>
                           {t("Save and Continue")}
                        </button>
                    </div>
                   </>
               }
                </div>
                </div>
                }
                
                />
        </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        passengerCount:state.travel.passengerCount,
        passengerDetails:state.travel.passengerDetails,
        passengerCountDetails:state.travel.passengerCountDetails,
        flightDetails:state.travel.selectedFlightDetail?.search?.data,
        contactDetails:state.travel.contactDetails,
        SelectedCountryName:state.countries.selectedCountry?.countryName,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addPassengerDetails:(details,uid) => dispatch(addPassengersDetails(details,uid)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouter(PassengerDetails)));
